export default __webpack_public_path__ + "static/media/top-banner.8f5f1e0a.png";